import React from 'react';
import { FL150 } from '../../../services/l205Api';
import { dateToInput, inputToDate, getPeriodFromDate } from '../helpers';

interface Tab1Props {
  formData: Partial<FL150>;
  isEditing: boolean;
  isFieldDisabled: (key: string) => boolean;
  getField: (key: keyof FL150) => FL150[keyof FL150];
  setField: (key: keyof FL150, value: FL150[keyof FL150]) => void;
  getFieldError?: (field: string) => string | undefined;
}

const Tab1BasicInfo: React.FC<Tab1Props> = ({
  formData, isEditing, isFieldDisabled,
  getField, setField, getFieldError,
}) => {
  const E = (field: string) => {
    const err = getFieldError?.(field);
    return err ? <span style={{ color: '#ff4d4f', fontSize: 11, marginLeft: 6, fontWeight: 'normal' }}>{err}</span> : null;
  };

  const handleDateChange = (v: string) => {
    setField('fl150_11', inputToDate(v) as FL150[keyof FL150]);
    // Auto-set period based on month (BR-10)
    const period = getPeriodFromDate(v);
    setField('fl150_10', period as FL150[keyof FL150]);
  };

  return (
    <div className="form-sections">

      {/* Section: 基本資料 */}
      <div className="form-section odd">
        <span className="section-tag">基本資料</span>
        <div className="form-grid">
          <label>查檢表號</label>
          <div>
            <input
              type="text"
              readOnly
              style={{ maxWidth: 120 }}
              value={getField('fl150_01') as string || '(自動產生)'}
            />
          </div>

          <label className="required">日期{E('fl150_11')}</label>
          <div>
            <input
              type="date"
              style={{ maxWidth: 180 }}
              disabled={isFieldDisabled('fl150_11')}
              value={dateToInput(getField('fl150_11') as string)}
              onChange={e => handleDateChange(e.target.value)}
            />
          </div>

          <label>次別{E('fl150_10')}</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="period"
                value={1}
                checked={(getField('fl150_10') as number) === 1}
                disabled={isFieldDisabled('fl150_10')}
                onChange={() => setField('fl150_10', 1 as FL150[keyof FL150])}
              />
              上半年（01~06月）
            </label>
            <label>
              <input
                type="radio"
                name="period"
                value={2}
                checked={(getField('fl150_10') as number) === 2}
                disabled={isFieldDisabled('fl150_10')}
                onChange={() => setField('fl150_10', 2 as FL150[keyof FL150])}
              />
              下半年（07~12月）
            </label>
          </div>
        </div>
      </div>

      {/* Section: 人員資訊 */}
      <div className="form-section even">
        <span className="section-tag">人員資訊</span>
        <div className="form-grid">
          <label className="required">稽核人{E('fl150_14')}</label>
          <div>
            <input
              type="text"
              style={{ maxWidth: 140 }}
              maxLength={8}
              disabled={isFieldDisabled('fl150_14')}
              value={getField('fl150_14') as string}
              onChange={e => setField('fl150_14', e.target.value as FL150[keyof FL150])}
            />
          </div>

          <label className="required">管理代表{E('fl150_81')}</label>
          <div>
            <input
              type="text"
              style={{ maxWidth: 140 }}
              maxLength={8}
              disabled={isFieldDisabled('fl150_81')}
              value={getField('fl150_81') as string}
              onChange={e => setField('fl150_81', e.target.value as FL150[keyof FL150])}
            />
          </div>

          <label>部門代碼{E('fl150_12')}</label>
          <div>
            <input
              type="text"
              style={{ maxWidth: 140 }}
              maxLength={4}
              disabled={isFieldDisabled('fl150_12')}
              value={getField('fl150_12') as string}
              onChange={e => setField('fl150_12', e.target.value as FL150[keyof FL150])}
            />
          </div>

          <label>受稽核人(表頭){E('fl150_13')}</label>
          <div>
            <input
              type="text"
              style={{ maxWidth: 140 }}
              maxLength={8}
              disabled={isFieldDisabled('fl150_13')}
              value={getField('fl150_13') as string}
              onChange={e => setField('fl150_13', e.target.value as FL150[keyof FL150])}
            />
          </div>

          <label>總項數</label>
          <div>
            <input
              type="number"
              readOnly
              disabled
              style={{ maxWidth: 80 }}
              value={formData.fl150_15 ?? 0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Tab1BasicInfo);
